/** Random delay before showing a boot line as `done` (ms, inclusive). */
const BOOT_DONE_JITTER_MIN = 80;
const BOOT_DONE_JITTER_MAX = 320;

export function bootDoneJitterMs(): number {
  return Math.floor(BOOT_DONE_JITTER_MIN + Math.random() * (BOOT_DONE_JITTER_MAX - BOOT_DONE_JITTER_MIN + 1));
}
